<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list"></i>
          <strong>
            {{ title }}
            <b-button-group class="float-right ml-1" size="sm">
              <b-button
                v-for="(btn, idx) in buttons"
                :key="idx"
                @click="
                  e => {
                    e.target.blur();
                    onlyOne(idx);
                    component = 'stock-list';
                  }
                "
                :pressed.sync="btn.state"
                variant="primary"
              >
                {{ btn.caption }}
              </b-button>
            </b-button-group>
            <b-spinner v-if="loading" class="float-right" small />
          </strong>
        </div>
        <div>
          <stock-list
            :column_display="column_display"
            :columns="columns"
            :filterable="filterable"
            :headings="headings"
            :list-columns="listColumns"
            :url="url"
            @on-loading="loading = $event"
          />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import StockList from "../ServerFilterableTable2";

export default {
  name: "DetailedStock",
  components: {
    StockList
  },
  data() {
    return {
      title: "Listado de stock",
      component: null,
      product__product_type__name: null,
      buttons: [
        { caption: "GRANEL", state: true },
        { caption: "CALIBRADO", state: false },
        { caption: "DESCARTE", state: false },
        { caption: "PT", state: false }
      ],
      loading: false,
      column_display: {
        product_family: "not_desktop",
        product_fruit: "not_desktop",
        "product_type.name": "",
        lot: "",
        product_code: "",
        product: "",
        number: "",
        quantity: "",
        container: "",
        creation_date: "not_desktop",
        net_kilograms: "",
        gross_kilograms: "",
        position: "not_desktop"
      },
      columns: [
        "id",
        "product_family",
        "product_fruit",
        "product_code",
        "product",
        // "product_type.name",
        "lot",
        "stock_area",
        "number",
        "container",
        "quantity",
        "creation_date",
        "net_kilograms"
      ],
      filterable: [
        "product",
        "product_code",
        "product_type.name",
        "lot",
        "container",
        "creation_date",
        "stock_area",
        "number",
        "product_fruit",
        "product_family"
      ],
      headings: {
        id: "",
        product_family: "Familia",
        product_fruit: "Fruta",
        "product_type.name": "Tipo",
        lot: "Lote",
        number: "Número",
        product_code: "Código",
        product: "Producto",
        quantity: "Cantidad",
        container: "Recipiente",
        creation_date: "fecha",
        net_kilograms: "KN",
        gross_kilograms: "KB",
        stock_area: "Área"
      },
      listColumns: {
        document_type: [
          { id: 0, text: "Guia de despacho" },
          { id: 1, text: "Factura" },
          { id: 2, text: "Otro" }
        ]
      }
    };
  },
  methods: {
    onlyOne(idx) {
      for (let i in this.buttons) {
        this.buttons[i].state = false;
      }
      this.buttons[idx].state = true;
    }
  },
  computed: {
    stock_area_filter_constructor() {
      let filter = this.$route.params;
      filter = !_.isEmpty(filter)
        ? filter.process_type_complete.stockarea_set
            .map(e => e.id)
            .join("|stock_area=")
        : "";
      filter +=
        "&product__product_type__name=" +
        this.buttons
          .filter(e => e.state)
          .map(e => e.caption)
          .join("|product__product_type__name=");
      return "stock_area=" + filter;
    },
    url() {
      return "/bagno/content-stock/?" + this.stock_area_filter_constructor;
    }
  }
};
</script>

<style scoped></style>
